var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M33.154 14c1.054 0 1.45.074 1.84.283.312.166.557.411.723.723.209.39.283.786.283 1.84v13.308c0 1.054-.074 1.45-.283 1.84a1.74 1.74 0 01-.723.723c-.39.209-.786.283-1.84.283H14.846c-1.054 0-1.45-.074-1.84-.283a1.74 1.74 0 01-.723-.723c-.209-.39-.283-.786-.283-1.84V16.846c0-1.054.074-1.45.283-1.84a1.74 1.74 0 01.723-.723c.39-.209.786-.283 1.84-.283z", stroke: "currentColor", strokeWidth: 2 }),
            React.createElement("path", { d: "M29.197 21.414L36 28.217V30a3 3 0 01-3 3H14.783l11.586-11.586a2 2 0 012.828 0z", fill: "currentColor" }),
            React.createElement("path", { d: "M16.69 24.414l-4.907 4.907V30a3 3 0 003 3h13.32l-8.585-8.586a2 2 0 00-2.828 0z", fill: "currentColor" }),
            React.createElement("circle", { fill: "currentColor", cx: 17, cy: 19, r: 2 }))));
});
